// extracted by mini-css-extract-plugin
export default {"chartContainer":"SocialMessageAmount_chartContainer__ULiH8","total":"SocialMessageAmount_total__l-6+G"};